import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "redux/store";
import { setIsLoading, setShowToast } from "../rfpModuleSlice/application";
import { api } from "api/axiosInterceptor";
import { apiUrl } from "api/apiUrl";
import { convertToCamelCase } from "utils/utils";
import { IHrTimelineState, HrTimelineInfo } from "types/hrApplications";

const initialState: IHrTimelineState = {
  timelineInfo: {
    data: {},
    users: [],
  },
  analysedApplications: {}
};

const slice = createSlice({
  name: "hrApplications",
  initialState,
  reducers: {
    setHrTimelineInfo(state, action: PayloadAction<HrTimelineInfo>) {
      state.timelineInfo = action.payload;
    },
    setHrAnalysedApplications(state, action: PayloadAction<any>) {
      state.analysedApplications = action.payload;
    },
  },
});

export const { setHrTimelineInfo, setHrAnalysedApplications } = slice.actions;

export default slice.reducer;

export const getHrTimeline = () => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true));
  try {
    const path = `${apiUrl.hr}evalution/timeline/`;
    const response = await api.get(path);
    const formattedData = convertToCamelCase(response.data) as HrTimelineInfo;
    dispatch(setHrTimelineInfo(formattedData));
    return response.status;
  } catch (error) {
    dispatch(
      setShowToast({
        show: true,
        type: "error",
        toastMessage: "Failed to fetch timeline data. Please try again.",
      })
    );
  } finally {
    dispatch(setIsLoading(false));
  }
};

export const getHrAnalysedApplications = (pageNumber = 1, pageLength = 10, state: 'Active' | 'Inactive' | 'Completed' = 'Completed') => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true));
  try {
    const path = `${apiUrl.hr}applicatons/`;
    const response = await api.post(path,{
      page_length: pageLength,
      page_number: pageNumber,
      state,
    });
    const formattedData = convertToCamelCase(response.data) as HrTimelineInfo;
    dispatch(setHrAnalysedApplications(formattedData));
    return response.status;
  } catch (error) {
    dispatch(setShowToast({
      show: true,
      type: "error",
      toastMessage: "Failed to fetch timeline data. Please try again.",
    }));
  } finally {
    dispatch(setIsLoading(false));
  }
};